module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/b0001-home/b0001-accept-modal.component.css
// module id = ./src/app/b0001-home/b0001-accept-modal.component.css
// module chunks = main